// extracted by mini-css-extract-plugin
export default {"container":"JSONEditor_container__EkEBr","editor":"JSONEditor_editor__HUAFn"};